export function scriptExists(srcPath) {
  const scripts = document.getElementsByTagName('script');
  let i = scripts.length;
  let flag = false;
  while (i--) {
    if (scripts[i].src === srcPath) {
      flag = true;
      break;
    }
  }
  return flag;
}
